import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "continue" ]

    connect() {
        this.lastClickTarget = null;

        this.handleClick = (event) => {
            this.lastClickTarget = event.target;
        };
        document.addEventListener("click", this.handleClick, true);

        this.handleBeforeUnload = (event) => {
            if (this.continueTarget && this.continueTarget.contains(this.lastClickTarget)) {
                return;
            }
            event.preventDefault();
        };

        window.addEventListener("beforeunload", this.handleBeforeUnload);
    }

    disconnect() {
        document.removeEventListener("click", this.handleClick, true);
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }
}